<template>
	<div v-if="wasModified() || !old || !otherName">
		<v-flex d-flex xs12>
			<v-card :color="color()">
				<v-card-text>
					<strong>
						{{parentSerialNumber}}{{parentSerialNumber ? "." : ""}}{{serialNumber}} &emsp;{{name}}
						{{status()}}
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>


		<final-report-comparison-large-row
			:old="old"
			first-cell-label=""
			:cells-color-intensity="-4"
			:first-cell-color="color()"
			:cells-formatter="formatMoney"
			:other-exists="(otherName !== undefined && otherName !== null && otherName !== '')"

			:cells-values="[cost.fromProjectSum,
				fromDotationFromProject(cost),
				fromOtherFromProject(cost),
				fromOwnHumanFromProject(cost),
				fromOwnInKindFromProject(cost),
				cost.fromDocumentSum,
				fromDotationFromDocument(cost),
				fromOtherFromDocument(cost),
				fromOwnHumanFromDocument(cost),
				fromOwnInKindFromDocument(cost),
				fromInterestsFromDocument(cost)]"

			:cells-other-values="[otherCost.fromProjectSum,
				fromDotationFromProject(otherCost),
				fromOtherFromProject(otherCost),
				fromOwnHumanFromProject(otherCost),
				fromOwnInKindFromProject(otherCost),
				otherCost.fromDocumentSum,
				fromDotationFromDocument(otherCost),
				fromOtherFromDocument(otherCost),
				fromOwnHumanFromDocument(otherCost),
				fromOwnInKindFromDocument(otherCost),
				fromInterestsFromDocument(otherCost)]"
		/>

	</div>
</template>

<script>
	import {ComparisonResult} from "./Utils/ComparisonResult";
	import {FinalReportComparisonUtils} from "./Utils/FinalReportComparisonUtils";
	import FinalReportComparisonLargeRow from "./FinalReportComparisonLargeRow";
	import {Numbers} from "../../../utils/Numbers";
	import {FinalReportCostsUtils} from "./Utils/FinalReportCostsUtils";

	export default {
		name: "FinalReportComparisonSingleCost",
		components: {FinalReportComparisonLargeRow},

		mixins: [Numbers, FinalReportCostsUtils],

		props: {
			parentSerialNumber: {},
			serialNumber: {},
			name: {},
			costDivisionsFromProject: {},
			costDivisionsFromDocuments: {},
			otherName: {},
			otherCostDivisionsFromProject: {},
			otherCostDivisionsFromDocuments: {},
			old: {}
		},

		computed: {
			cost () {
				let result = {
					fromDocument: this.costDivisionsFromDocuments,
					fromProject: this.costDivisionsFromProject
				};
				this.postprocessMerged(result);
				return result;
			},

			otherCost () {
				let result = {
					fromDocument: this.otherCostDivisionsFromDocuments,
					fromProject: this.otherCostDivisionsFromProject
				};
				this.postprocessMerged(result);
				return result;
			},

		},

		methods: {

			color () {
				return FinalReportComparisonUtils.comparisonColor(this.status(), -3);
			},

			wasModified () {
				return this.status() !== ComparisonResult.same;
			},

			status () {
				return FinalReportComparisonUtils.getComparisonStatusCost(
					this.name,
					this.otherName,
					this.costDivisionsFromDocuments,
					this.otherCostDivisionsFromDocuments,
					this.costDivisionsFromProject,
					this.otherCostDivisionsFromProject,
					this.old);
			}
		}
	};
</script>

<style scoped>

</style>